const dataGeography = {
  id18001: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Afghanistan ?",
    answers: ["Afghani", "Franc", "Dollar", "Roupie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18002: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Afrique du Sud ?",
    answers: ["Dollar", "Lempira", "Rand", "Couronne"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18003: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Albanie ?",
    answers: ["Yen", "Lek", "Afghani", "Lilangeni"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18004: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Algérie ?",
    answers: ["Dollar algérien", "Dinar algérien", "Livre", "Kina"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18005: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Allemagne ?",
    answers: ["Manat", "Euro", "Lempira", "Couronne"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18006: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Andorre ?",
    answers: ["Euro", "Rand", "Won", "Couronne"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18007: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Angola ?",
    answers: ["Cedi", "Kwanza", "Franc", "Dinar"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18008: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Arabie Saoudite ?",
    answers: ["Kyat", "Franc", "Riyal saoudien", "Lev"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18009: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Argentine ?",
    answers: ["Peso argentin", "Dinar argentin", "Dollar argentin", "Kyat"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18010: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Arménie ?",
    answers: ["Dram", "Roupie", "Leu", "Euro"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18011: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Antigua-et-Barbuda ?",
    answers: ["Colón", "Dollar des Caraïbes orientales", "Dinar", "Euro"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18012: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Australie ?",
    answers: ["Dirham", "Dollar australien", "Livre australienne", "Mark"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18013: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Autriche ?",
    answers: ["Rouble", "Euro", "Shilling", "Dinar"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18014: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Azerbaïdjan ?",
    answers: ["Leone", "Peso", "Dollar azerbaïdjanais", "Manat azerbaïdjanais"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18015: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Bahamas ?",
    answers: ["Pula", "Dollar bahaméen", "Franc bahaméen", "Kwacha"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18016: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Bahreïn ?",
    answers: ["Kyat", "Dinar bahreïni", "Livre bahreïni", "Dollar bahreïni"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18017: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Bangladesh ?",
    answers: ["Taka", "Won", "Dollar", "Rouble"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18018: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Barbade ?",
    answers: ["Lempira", "Livre barbadienne", "Bolívar", "Dollar barbadien"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18019: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Belgique ?",
    answers: ["Euro", "Tugrik", "Dobra", "Franc"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18020: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Belize ?",
    answers: ["Lev", "Ariary", "Couronne bélizienne", "Dollar bélizien"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18021: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Bénin ?",
    answers: ["Franc CFA (BCEAO)", "Som ouzbek", "Dollar", "Kwacha"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18022: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Bhoutan ?",
    answers: ["Shilling", "Forint", "Ngultrum", "Afghani"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18023: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Biélorussie ?",
    answers: ["Som ouzbek", "Nakfa", "Dollar biélorusse", "Rouble biélorusse"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18024: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Birmanie ?",
    answers: ["Kwacha", "Som", "Kyat", "Dollar"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18025: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Bolivie ?",
    answers: ["Livre", "Boliviano", "Peso", "Rouble"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18026: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Bosnie-Herzégovine ?",
    answers: ["Dinar", "Dollar", "Euro", "Mark convertible"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18027: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Botswana ?",
    answers: ["Leone", "Dinar", "Guarani", "Pula"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18028: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Brésil ?",
    answers: ["Dinar", "Réal brésilien", "Birr", "Riyal"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18029: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Bulgarie ?",
    answers: ["Mark convertible", "Lev", "Rial", "Dinar"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18030: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Burkina Faso ?",
    answers: ["Livre", "Franc CFA (BCEAO)", "Dinar", "Shilling"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18031: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Burundi ?",
    answers: ["Manat burundais", "Franc burundais", "Lilangeni", "Rouble burundais"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18032: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Cambodge ?",
    answers: ["Riel", "Roupie", "Dollar", "Tenge"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18033: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Cameroun ?",
    answers: ["Lempira", "Franc CFA (BCEAO)", "Lek", "Franc CFA (BEAC)"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18034: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Canada ?",
    answers: ["Córdoba", "Dollar canadien", "Peso canadien", "Pa'anga"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18035: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Cap-Vert ?",
    answers: ["Roupie", "Livre sterling", "Ngultrum", "Escudo capverdien"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18036: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Chili ?",
    answers: ["Ringgit", "Peso chilien", "Franc CFA (BEAC)", "Manat"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18037: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Chine ?",
    answers: ["Euro", "Dollar américain", "Yuan", "Rouble"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18038: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Chypre ?",
    answers: ["Livre", "Roupie", "Euro", "Rouble"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18039: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Colombie ?",
    answers: ["Colón", "Som ouzbek", "Rand", "Peso colombien"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18040: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Comores ?",
    answers: ["Rouble", "Franc comorien", "Hryvnia", "Lempira"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18041: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Corée du Nord ?",
    answers: ["Kwanza", "Won nord-coréen", "Lilangeni", "Córdoba"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18042: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Corée du Sud ?",
    answers: ["Won sud-coréen", "Dollar", "Sol", "Franc"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18043: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Costa Rica ?",
    answers: ["Livre", "Som", "Dollar", "Colón"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18044: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Côte d'Ivoire ?",
    answers: ["Franc CFA (BCEAO)", "Couronne", "Peso", "Riyal"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18045: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Croatie ?",
    answers: ["Dinar", "Lari", "Rouble", "Euro"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18046: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Cuba ?",
    answers: ["Dinar", "Peso cubain", "Rouble", "Cedi"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18047: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Danemark ?",
    answers: ["Couronne danoise", "Roupie", "Dinar", "Lilangeni"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18048: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Djibouti ?",
    answers: ["Franc djiboutien", "Roupie", "Livre", "Tala"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18049: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Dominique ?",
    answers: ["Euro", "Kwacha", "Dollar des Caraïbes orientales", "Dobra"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18050: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Égypte ?",
    answers: ["Kwacha", "Livre égyptienne", "Ariary", "Riel"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18051: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Émirats arabes unis ?",
    answers: ["Dirham des Émirats arabes unis", "Peso", "Franc", "Dollar des Émirats arabes unis"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18052: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Équateur ?",
    answers: ["Tugrik", "Couronne", "Dollar américain", "Afghani"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18053: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Érythrée ?",
    answers: ["Nakfa", "Franc", "Tugrik", "Som ouzbek"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18054: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Espagne ?",
    answers: ["Baht", "Livre", "Euro", "Dollar"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18055: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Estonie ?",
    answers: ["Tala", "Dollar", "Euro", "Dinar"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18056: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des États-Unis ?",
    answers: ["Leu", "Dollar américain", "Shekel", "Franc"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18057: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Eswatini ?",
    answers: ["Couronne", "Birr", "Lek", "Lilangeni"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18058: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Éthiopie ?",
    answers: ["Dollar", "Dirham", "Dinar", "Birr"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18059: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Fidji ?",
    answers: ["Manat", "Dollar fidjien", "Shilling fidjien", "Birr"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18060: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Finlande ?",
    answers: ["Peso", "Euro", "Rand", "Couronne finlandaise"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18061: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la France ?",
    answers: ["Euro", "Yen", "Dollar", "Shekel"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18062: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Gabon ?",
    answers: ["Franc CFA (BEAC)", "Manat", "Or du Gabon", "Dinar"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18063: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Gambie ?",
    answers: ["Dinar", "Dalasi", "Balboa", "Roupie"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18064: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Géorgie ?",
    answers: ["Dinar", "Dirham ", "Lari", "Kwacha"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18065: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Ghana ?",
    answers: ["Franc CFA (BCEAO)", "Cedi", "Leone", "Couronne"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18066: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Grèce ?",
    answers: ["Franc", "Euro", "Yuan", "Loti"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18067: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Grenade ?",
    answers: ["Leu", "Franc CFA (BCEAO)", "Dollar des Caraïbes orientales", "Livre"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18068: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Guatemala ?",
    answers: ["Shilling", "Lev", "Quetzal", "Afghani"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18069: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Guinée ?",
    answers: ["Dollar des Caraïbes orientales", "Franc guinéen", "Quetzal", "Dinar"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18070: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Guinée-Bissau ?",
    answers: ["Peso", "Livre", "Forint", "Franc CFA (BCEAO)"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18071: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Guinée équatoriale ?",
    answers: ["Kwacha", "Hryvnia", "Peso", "Franc CFA (BEAC)"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18072: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Guyane ?",
    answers: ["Rial", "Ringgit", "Peso", "Dollar guyanien"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18073: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Haïti ?",
    answers: ["Manat", "Gourde", "Peso", "Zloty"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18074: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Honduras ?",
    answers: ["Lempira", "Franc", "Shekel", "Dinar"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18075: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Hongrie ?",
    answers: ["Dinar", "Lari", "Tenge", "Forint"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18076: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Îles Marshall ?",
    answers: ["Dollar américain", "Dinarn", "Bolívar", "Somoni"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18077: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle desÎles Salomon ?",
    answers: ["Rial", "Dollar des Salomon", "Mark convertible", "Lempira"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18078: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Inde ?",
    answers: ["Ouguiya", "Birr", "Dollar", "Roupie indienne"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18079: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Indonésie ?",
    answers: ["Dollar", "Nakfa", "Baht", "Roupie indonésienne"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18080: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Irak ?",
    answers: ["Dinar irakien", "Tenge", "Dong", "Rufiyaa"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18081: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Iran ?",
    answers: ["Rial iranien", "Escudo", "Rouble", "Lari"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18082: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Irlande ?",
    answers: ["Euro", "Hryvnia", "Som", "Livre"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18083: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Islande ?",
    answers: ["Dollar", "Franc", "Yen", "Couronne islandaise"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18084: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle d'Israël ?",
    answers: ["Peso", "Riyal", "Kip", "Shekel"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18085: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Italie ?",
    answers: ["Dollar", "Riyal", "Córdoba", "Euro"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18086: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Jamaïque ?",
    answers: ["Rand", "Dollar jamaïcain", "Sol", "Rial jamaïcain"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18087: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Japon ?",
    answers: ["Mark convertible", "Roupie", "Livre", "Yen"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18088: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Jordanie ?",
    answers: ["Yuan", "Franc", "Rouble jordanien", "Dinar jordanien"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18089: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Kazakhstan ?",
    answers: ["Ouguiya", "Tenge", "Ringgit", "Euro"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18090: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Kenya ?",
    answers: ["Livre", "Riel", "Peso", "Shilling kényan"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18091: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Kirghizistan ?",
    answers: ["Kwacha", "Taka", "Som", "Rand"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18092: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Kiribati ?",
    answers: ["Livre", "Shilling", "Kwacha", "Dollar australien"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18093: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Koweït ?",
    answers: ["Dollar koweïtien", "Dinar koweïtien", "Peso koweïtien", "Kwanza"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18094: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Laos ?",
    answers: ["Kip", "Birr", "Couronne", "Franc"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18095: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Lesotho ?",
    answers: ["Ouguiya", "Loti", "Tenge", "Som"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18096: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Lettonie ?",
    answers: ["Euro", "Gourde", "Tala", "Loti"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18097: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Liban ?",
    answers: ["Livre libanaise", "Dollar libanais", "Leone", "Euro"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18098: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Libéria ?",
    answers: ["Roupie libérienne", "Dollar libérien", "Livre libérienne", "Franc libérien"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18099: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Libye ?",
    answers: ["Riyal libyen", "Couronne", "Won", "Dinar libyen"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18100: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Liechtenstein ?",
    answers: ["Franc suisse", "Couronne", "Afghani", "Dinar"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18101: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Lituanie ?",
    answers: ["Franc CFA (BCEAO)", "Rial", "Kyat", "Euro"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18102: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Luxembourg ?",
    answers: ["Yuan", "Franc CFA (BEAC)", "Euro", "Escudo"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18103: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Madagascar ?",
    answers: ["Yuan", "Ariary", "Gourde", "Dirham"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18104: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Malaisie ?",
    answers: ["Dollar", "Kina", "Lari", "Ringgit"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18105: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Malawi ?",
    answers: ["Kwacha malawite", "Franc malawite", "Roupie malawite", "Somoni"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18106: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Maldives ?",
    answers: ["Peso", "Rufiyaa", "Dollar", "Loti"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18107: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Mali ?",
    answers: ["Livre sterling", "Dollar", "Franc CFA (BCEAO)", "Dobra"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18108: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Malte ?",
    answers: ["Tenge", "Dollar", "Lari", "Euro"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18109: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Maroc ?",
    answers: ["Lev", "Won", "Dinar marocain", "Dirham marocain"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18110: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Île Maurice ?",
    answers: ["Kwacha", "Roupie mauricienne", "Leu", "Peso"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18111: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Mauritanie ?",
    answers: ["Ouguiya", "Lek", "Roupie", "Franc"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18112: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Mexique ?",
    answers: ["Ngultrum", "Peso mexicain", "Rouble", "Riyal"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18113: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Micronésie ?",
    answers: ["Franc", "Mark convertible", "Dollar américain", "Livre"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18114: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Moldavie ?",
    answers: ["Dollar moldave", "Peso moldave", "Leu moldave", "Ngultrum"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18115: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Monaco ?",
    answers: ["Dollar", "Kwacha", "Euro", "Livre"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18116: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Mongolie ?",
    answers: ["Dollar", "Ouguiya", "Dinar", "Tugrik"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18117: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Monténégro ?",
    answers: ["Sol", "Peso mexicain", "Peso dominicain", "Euro"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18118: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Namibie ?",
    answers: ["Sol", "Tugrik", "Dollar namibien", "Dinar namibien"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18119: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Nauru ?",
    answers: ["Dinar", "Dollar australien", "Rouble", "Franc"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18120: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Népal ?",
    answers: ["Dollar népalais", "Peso", "Riyal", "Roupie népalaise"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18121: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Nicaragua ?",
    answers: ["Escudo", "Rufiyaa", "Rand", "Córdoba"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18122: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Niger ?",
    answers: ["Franc CFA (BCEAO)", "Kwacha", "Peso", "Córdoba"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18123: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Norvège ?",
    answers: ["Couronne norvégienne", "Dong", "Kwacha", "Peso"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18124: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Nouvelle-Zélande ?",
    answers: ["Rouble", "Som ouzbek", "Roupie", "Dollar néo-zélandais"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18125: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Oman ?",
    answers: ["Dollar omanais", "Dinar omanais", "Rial omanais", "Dong"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18126: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Ouganda ?",
    answers: ["Dinar ougandais", "Roupie ougandaise", "Shilling ougandais", "Dollar ougandais"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18127: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Ouzbékistan ?",
    answers: ["Dinar ouzbek", "Lempira", "Som ouzbek", "Riyal ouzbek"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18128: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Pakistan ?",
    answers: ["Dinar pakistanais", "Córdoba", "Roupie pakistanaise", "Euro"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18129: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Palaos ?",
    answers: ["Rial", "Ouguiya", "Dollar américain", "Gourde"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18130: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Panama ?",
    answers: ["Dollar", "Couronne", "Dirham", "Balboa"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18131: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Papouasie-Nouvelle-Guinée ?",
    answers: ["Nakfa", "Birr", "Kina", "Livre"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18132: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Paraguay ?",
    answers: ["Dalasi", "Couronne", "Guarani", "Dinar"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18133: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Pays-Bas ?",
    answers: ["Yuan", "Dollar", "Manat", "Euro"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18134: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle duPérou ?",
    answers: ["Pa'anga", "Won", "Sol", "Or du Pérou"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18135: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Philippines ?",
    answers: ["Euro", "Manat", "Dollar philippin", "Peso philippin"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18136: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Pologne ?",
    answers: ["Dinar", "Zloty", "Rufiyaa", "Dollar"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18137: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Portugal ?",
    answers: ["Euro", "Pa'anga", "Zloty", "Ariary"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18138: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Qatar ?",
    answers: ["Roupie qatari", "Dinar qatari", "Riyal qatari", "Livre qatari"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18139: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la République centrafricaine ?",
    answers: ["Dinar", "Baht", "Franc CFA (BEAC)", "Dollar"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18140: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la République démocratique du Congo ?",
    answers: ["Rial", "Rouble", "Franc congolais", "Hryvnia"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18141: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la République dominicaine ?",
    answers: ["Shekel", "Dollar", "Dong", "Peso dominicain"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18142: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Roumanie ?",
    answers: ["Ariary", "Riyal", "Leu roumain", "Ringgit"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18143: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Royaume-Uni ?",
    answers: ["Riyal", "Balboa", "Franc", "Livre sterling"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18144: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Russie ?",
    answers: ["Rouble russe", "Roupie", "Bolívar", "Dram"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18145: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Rwanda ?",
    answers: ["Livre", "Dollar rwandais", "Franc rwandais", "Manat"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18146: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Saint-Christophe-et-Niévès ?",
    answers: ["Forint", "Manat", "Som", "Dollar des Caraïbes orientales"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18147: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Saint-Marin ?",
    answers: ["Roupie", "Livre", "Euro", "Won"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18148: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Saint-Vincent-et-les-Grenadines ?",
    answers: ["Roupie", "Dollar des Caraïbes orientales", "Livre sterling", "Quetzal"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18149: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Sainte-Lucie ?",
    answers: ["Yen", "Manat", "Dollar des Caraïbes orientales", "Franc"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18150: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Salvador ?",
    answers: ["Bolívar", "Peso", "Rand", "Dollar américain"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18151: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Samoa ?",
    answers: ["Peso", "Taka", "Franc", "Tala"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18152: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de São Tomé-et-Principe ?",
    answers: ["Roupie", "Dobra", "Dollar", "Dram"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18153: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Sénégal ?",
    answers: ["Franc CFA (BCEAO)", "Dollar", "Shilling", "Kwacha"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18154: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Serbie ?",
    answers: ["Dinar", "Rouble", "Dinar serbe", "Nakfa"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18155: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Seychelles ?",
    answers: ["Won", "Roupie", "Yuan", "Dinar"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18156: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Sierra Leone ?",
    answers: ["Lev", "Euro", "Leone", "Baht"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18157: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Singapour ?",
    answers: ["Dollar de Singapour", "Kwanza", "Lev", "Yuan"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18158: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Slovaquie ?",
    answers: ["Euro", "Manat", "Roupie", "Dollar"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18159: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Slovénie ?",
    answers: ["Rand", "Peso", "Lari", "Euro"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18160: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Somalie ?",
    answers: ["Tugrik", "Yen", "Ringgit", "Shilling somalien"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18161: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Soudan ?",
    answers: ["Livre soudanaise", "Dong", "Peso", "Gourde"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18162: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Soudan du Sud ?",
    answers: ["Birr", "Lev", "Livre soudanaise", "Livre sud-soudanaise"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18163: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Sri Lanka ?",
    answers: ["Bolívar", "Rial", "Roupie srilankaise", "Livre srilankaise"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18164: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Suède ?",
    answers: ["Dalasi", "Couronne suédoise", "Dollar", "Euro"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18165: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Suisse ?",
    answers: ["Hryvnia", "Franc suisse", "Dollar", "Euro"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18166: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Suriname ?",
    answers: ["Dollar surinamien", "Vatu", "Franc", "Tugrik"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18167: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Syrie ?",
    answers: ["Livre syrienne", "Boliviano", "Kyat", "Shilling Syrien"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18168: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Tadjikistan ?",
    answers: ["Manat", "Somoni", "Shilling", "Peso"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18169: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Tanzanie ?",
    answers: ["Dollar", "Franc", "Shilling tanzanien", "Lev"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18170: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Tchad ?",
    answers: ["Roupie", "Ariary", "Lev", "Franc CFA (BEAC)"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18171: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Tchéquie ?",
    answers: ["Leu", "Couronne tchèque", "Livre", "Dinar"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18172: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Thaïlande ?",
    answers: ["Kwacha", "Shilling", "Roupie", "Baht"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18173: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Timor oriental ?",
    answers: ["Leu", "Rand", "Dollar américain", "Guarani"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18174: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Togo ?",
    answers: ["Quetzal", "Mark", "Kip", "Franc CFA (BCEAO)"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18175: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Tonga ?",
    answers: ["Franc", "Ariary", "Pa'anga", "Roupie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18176: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de Trinité-et-Tobago ?",
    answers: ["Dollar de Trinité-et-Tobago", "Couronne", "Vatu", "Ariary"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18177: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Tunisie ?",
    answers: ["Roupie", "Couronne tunisienne", "Tala", "Dinar tunisien"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18178: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Turkménistan ?",
    answers: ["Couronne", "Riyal", "Peso", "Manat turkmène"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18179: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Turquie ?",
    answers: ["Baht", "Lilangeni", "Leu", "Livre turque"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18180: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle des Tuvalu ?",
    answers: ["Dollar australien", "Lek", "Leu", "Peso"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18181: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Ukraine ?",
    answers: ["Shilling", "Hryvnia", "Roupie", "Livre sterling"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18182: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de l'Uruguay ?",
    answers: ["Peso uruguayen", "Shilling", "Dalasi", "Dollar"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18183: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Vanuatu ?",
    answers: ["Mark convertible", "Livre", "Vatu", "Peso"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18184: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Vatican ?",
    answers: ["Somk", "Euro", "Dram", "Dollar"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18185: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Venezuela ?",
    answers: ["Roupie", "Bolívar", "Peso", "Dollar"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18186: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Viêt Nam ?",
    answers: ["Dollar", "Som", "Dong", "Quetzal"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18187: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Yémen ?",
    answers: ["Dollar yéménite", "Rial yéménite", "Leu", "Ouguiya"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18188: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle de la Zambie ?",
    answers: ["Kyat", "Kwacha zambien", "Kina", "Tenge"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18189: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Quelle est la monnaie officielle du Zimbabwe ?",
    answers: ["Escudo", "Franc", "Forint", "Or du Zimbabwe"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18190: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle l'Afghani ?",
    answers: ["Nouvelle-Zélande", "Bangladesh", "Malaisie", "Afghanistan"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18191: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Rand ?",
    answers: ["Monaco", "Vatican", "Afrique du Sud", "Ouzbékistan"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18192: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Lek ?",
    answers: ["Singapour", "Barbade", "Albanie", "Colombie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18193: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Kwanza ?",
    answers: ["Botswana", "Burundi", "Angola", "Ukraine"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18194: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Dram ?",
    answers: ["Corée du Nord", "Tunisie", "Liban", "Arménie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18195: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Taka ?",
    answers: ["Seychelles", "Bangladesh", "Hongrie", "Iran"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18196: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Ngultrum ?",
    answers: ["Bhoutan", "Rwanda", "Soudan", "Mauritanie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18197: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Kyat ?",
    answers: ["Djibouti", "Chypre", "Afrique du Sud", "Birmanie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18198: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Boliviano ?",
    answers: ["Suède", "Birmanie", "Bolivie", "Arabie Saoudite"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18199: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Mark convertible ?",
    answers: ["Namibie", "Bosnie-Herzégovine", "Kazakhstan", "Corée du Sud"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18200: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Pula ?",
    answers: ["Serbie", "Bhoutan", "Botswana", "Saint-Marin"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18201: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Lev ?",
    answers: ["Tchéquie", "Ouganda", "Maurice", "Bulgarie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18202: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Riel ?",
    answers: ["Honduras", "Tonga", "Sénégal", "Cambodge"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18203: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Yuan ?",
    answers: ["Libye", "Chine", "Uruguay", "Qatar"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18204: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Colón ?",
    answers: ["Biélorussie", "Brésil", "Costa Rica", "Micronésie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18205: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Nakfa ?",
    answers: ["Népal", "Saint-Christophe-et-Niévès", "Salvador", "Érythrée"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18206: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Lilangeni ?",
    answers: ["Colombie", "Irlande", "Soudan du Sud", "Eswatini"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18207: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Birr ?",
    answers: ["Sri Lanka", "Monaco", "Éthiopie", "Indonésie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18208: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Dalasi ?",
    answers: ["Bahamas", "Gambie", "Arménie", "Lettonie"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18209: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Lari ?",
    answers: ["Papouasie-Nouvelle-Guinée", "Slovénie", "Serbie", "Géorgie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18210: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Cedi ?",
    answers: ["Monténégro", "Tadjikistan", "Ghana", "Saint-Vincent-et-les-Grenadines"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18211: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Quetzal ?",
    answers: ["Bahreïn", "Colombie", "Panama", "Guatemala"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18212: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Gourde ?",
    answers: ["Lituanie", "Honduras", "Haïti", "Maldives"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18213: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Lempira ?",
    answers: ["Japon", "Honduras", "Syrie", "Sri Lanka"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18214: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Forint ?",
    answers: ["Hongrie", "Russie", "Tonga", "Liechtenstein"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18215: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Shekel ?",
    answers: ["Israël", "République démocratique du Congo", "Pologne", "Papouasie-Nouvelle-Guinée"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18216: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Yen ?",
    answers: ["Danemark", "Japon", "Soudan", "Turquie"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18217: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Tenge ?",
    answers: ["Mongolie", "Qatar", "Kazakhstan", "Finlande"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18218: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Som ?",
    answers: ["Panama", "Portugal", "Libye", "Kirghizistan"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18219: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Kip ?",
    answers: ["Botswana", "Laos", "Royaume-Uni", "Liban"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18220: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Loti ?",
    answers: ["Monténégro", "Corée du Sud", "Lesotho", "Guinée-Bissau"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18221: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Ariary ?",
    answers: ["Madagascar", "Chypre", "Chili", "Arménie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18222: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Ringgit ?",
    answers: ["Niger", "Mongolie", "Malaisie", "Uruguay"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18223: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Rufiyaa ?",
    answers: ["Cambodge", "Inde", "Maldives", "France"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18224: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Ouguiya ?",
    answers: ["Mauritanie", "Maurice", "Hongrie", "Afghanistan"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18225: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Tugrik ?",
    answers: ["Mongolie", "Australie", "Suède", "Liechtenstein"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18226: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Córdoba ?",
    answers: ["Suriname", "Croatie", "Tunisie", "Nicaragua"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18227: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Som ouzbek ?",
    answers: ["Ouzbékistan", "Tanzanie", "Autriche", "Italie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18228: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Balboa ?",
    answers: ["Panama", "Turquie", "Pakistan", "Lesotho"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18229: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Kina ?",
    answers: ["Bénin", "Papouasie-Nouvelle-Guinée", "Sierra Leone", "Mauritanie"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18230: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Guarani ?",
    answers: ["Islande", "Botswana", "Paraguay", "Bénin"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18231: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Sol ?",
    answers: ["Sierra Leone", "Monaco", "Indonésie", "Pérou"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18232: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Zloty ?",
    answers: ["Pologne", "Suisse", "Bahamas", "Guinée équatoriale"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18233: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Tala ?",
    answers: ["Uruguay", "Grenade", "Guatemala", "Samoa"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18234: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Dobra ?",
    answers: ["Ouganda", "Équateur", "São Tomé-et-Principe", "Turquie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18235: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Leone ?",
    answers: ["Vatican", "Îles Salomon", "Sierra Leone", "Corée du Nord"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18236: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Somoni ?",
    answers: ["Tadjikistan", "Ghana", "Bénin", "Émirats arabes unis"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18237: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Baht ?",
    answers: ["Bénin", "Arabie Saoudite", "Thaïlande", "Australie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id18238: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Pa'anga ?",
    answers: ["Tonga", "Slovénie", "Mali", "Saint-Marin"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id18239: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Hryvnia ?",
    answers: ["Russie", "Ukraine", "Paraguay", "Lesotho"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18240: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Vatu ?",
    answers: ["Bolivie", "Autriche", "Hongrie", "Vanuatu"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id18241: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Bolívar ?",
    answers: ["Corée du Nord", "Venezuela", "Géorgie", "Israël"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id18242: {
    themes: ["Géographie", "Monnaies","Divers"],
    question: "Dans quel pays la monnaie officielle est-elle le Dong ?",
    answers: ["Pakistan", "Népal", "Paraguay", "Viêt Nam"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
};

export default dataGeography;